import { WbTable } from '@agilelab/plugin-wb-platform';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { FC, ReactNode, useMemo } from 'react';
import { Test } from '../types';

type Props = {
  children?: ReactNode;
};

export const TestTableLoading: FC<Props> = ({ children }) => {
  const configApi = useApi(configApiRef);
  const hasAssistant = useMemo(
    () =>
      configApi.getOptionalBoolean('assistant.enabled') &&
      configApi.getOptionalString('assistant.url') &&
      Boolean(localStorage.getItem('assistant')),
    [configApi],
  );

  return (
    <WbTable<Test>
      stickyHeader
      tableStyles={{ tableLayout: 'auto' }}
      components={{
        tableHeader: (
          <TableHead>
            <TableRow>
              <TableCell width="5%">Status</TableCell>
              <TableCell>ID / Date</TableCell>
              <TableCell>Results</TableCell>
              {hasAssistant && <TableCell width="5%" />}
            </TableRow>
          </TableHead>
        ),
        tableContent: {
          body: <TableBody>{children}</TableBody>,
        },
      }}
    />
  );
};
